import { render, staticRenderFns } from "./ProductFormStarter.vue?vue&type=template&id=61603f4d"
import script from "./ProductFormStarter.vue?vue&type=script&lang=js"
export * from "./ProductFormStarter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports